document.addEventListener("DOMContentLoaded", () => {
    const checkoutBtn = document.querySelector('input[name="checkout"]');

    if (!checkoutBtn) return;

    checkoutBtn.addEventListener("click", async (e) => {
        e.preventDefault();

        try {
            const res = await fetch("/cart.js", {
                cache: "no-store"
            });

            const cart = await res.json();

            const hasPaidProduct = cart.items.some(item => item.final_price > 0);

            if (!hasPaidProduct) {
     
                location.reload();
                return;
            }


            window.location.href = "/checkout";

        } catch (err) {
            console.error("Cart validation failed:", err);

 
            window.location.href = "/checkout";
        }
    });
});

// document.addEventListener('fgwo:gift-added', () => {
//     refreshCart();
// });
function lockFreeSample() {
  document.querySelectorAll('.ajaxcart__product').forEach(item => {
    const input = item.querySelector('input[data-id="54098468897078"]');
    if (!input) return;

    // Fix quantity
    input.value = 1;
    input.readOnly = true;

    // Remove controls
    item.querySelector('.cart__mini-qty')?.remove();
    item.querySelector('.remove-from-cart')?.remove();
     item.querySelectorAll('.ajaxcart__product-meta').forEach(meta => {
      meta.style.display = 'none';
    });

    // Disable product links
    item.querySelectorAll('a').forEach(link => {
      link.removeAttribute('href');
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
    });
  });
}

lockFreeSample();

new MutationObserver(lockFreeSample).observe(document.body, {
  childList: true,
  subtree: true
});


